// Arabic (RTL). Machine-drafted — review with a native speaker before launch.
import type { TranslationDictionary } from './en';

const ar: TranslationDictionary = {
	language: {
		label: 'اللغة',
		en: 'الإنجليزية',
		es: 'الإسبانية',
		fr: 'الفرنسية',
		ar: 'العربية',
	},
	help: {
		helpMenu: 'مساعدة',
		requestFeature: 'اقترح ميزة',
		helpDocs: 'المساعدة والوثائق',
		contactSupport: 'اتصل بالدعم',
	},
	nav: {
		dashboard: 'لوحة التحكم',
		cards: 'البطاقات',
		videoCards: 'بطاقات الفيديو',
		engagement: 'التفاعل',
		settings: 'الإعدادات',
		createNewCard: 'إنشاء بطاقة',
	},
	common: {
		save: 'حفظ',
		cancel: 'إلغاء',
		delete: 'حذف',
		edit: 'تعديل',
		search: 'بحث',
		loading: 'جارٍ التحميل…',
		download: 'تنزيل',
		share: 'مشاركة',
		close: 'إغلاق',
		back: 'رجوع',
		next: 'التالي',
	},
	viewcard: {
		header: 'مرحبًا %{name}، لقد أنشأ %{sender} بطاقة رقمية لك.',
		hi: 'مرحبًا',
		youHaveACard: 'لديك بطاقة!',
		tapEnvelopeToOpen: 'اضغط على الظرف لفتحه',
		sentYouACard: 'أرسل لك %{sender} بطاقة',
		tapToOpen: '👆 اضغط للفتح',
		tapOrSwipeToFlip: '👆 اضغط أو اسحب لتقليب البطاقة 👉',
		clickToOpen: 'انقر على البطاقة لفتحها.',
		tapToFlip: 'اضغط على البطاقة لتقليبها.',
		postcardFront: "وجه البطاقة البريدية. اضغط للتقليب.",
		postcardBack: "ظهر البطاقة البريدية. اضغط للتقليب.",
		createYourOwn: 'أنشئ بطاقتك المجانية',
		scrollToReact: 'مرّر للأسفل للتفاعل والتعليق ↓',
		reactToThisCard: 'تفاعل مع هذه البطاقة',
		comments: 'التعليقات',
		leaveComment: 'اترك تعليقًا',
		yourName: 'اسمك',
		writeMessage: 'اكتب رسالة… (500 حرف كحد أقصى)',
		post: 'نشر',
		postAnonymously: 'النشر بشكل مجهول',
		shareToWhatsapp: 'المشاركة عبر واتساب',
		copyLink: 'نسخ الرابط',
		linkCopied: 'تم نسخ الرابط!',
		shareViaEmail: 'المشاركة عبر البريد',
		shareOnX: 'المشاركة على X',
	},
	music: {
		play: 'تشغيل الموسيقى',
		pause: 'إيقاف الموسيقى مؤقتًا',
		volume: 'مستوى الصوت',
	},
	promo: {
		headline: 'أضف رسالة فيديو داخل بطاقاتك.',
		subline: 'دعهم يرونك ويسمعونك، لا أن يقرأوك فقط. دفعة واحدة، بدون اشتراك.',
		cta: 'وصول مدى الحياة',
		daysLeft: 'بقي %{count} يومًا',
		lastDay: 'اليوم الأخير',
	},
	unsub: {
		title: 'تفضيلات البريد الإلكتروني',
		confirmHeading: 'إلغاء الاشتراك في هذه الرسائل؟',
		confirmBody: 'لن تتلقى بعد الآن بطاقات أو رسائل من هذا المرسل. لن يتغير أي شيء آخر.',
		confirmButton: 'نعم، ألغِ اشتراكي',
		keepButton: 'لا، أبقِ اشتراكي',
		processing: 'جارٍ تحديث تفضيلاتك…',
		successHeading: 'تم إلغاء اشتراكك',
		successBody: 'لن تتلقى هذه الرسائل بعد الآن.',
		successNote: 'غيّرت رأيك؟ تواصل مع المرسل مباشرةً ليعيد إضافتك.',
		keptHeading: 'ما زلت مشتركًا',
		keptBody: 'لم يتم إجراء أي تغيير. يمكنك إغلاق هذه الصفحة.',
		errorHeading: 'حدث خطأ ما',
		errorBody: 'تعذّرت معالجة طلبك. يرجى المحاولة مرة أخرى بعد قليل.',
		errorMissing: 'رابط إلغاء الاشتراك غير مكتمل. يرجى استخدام الرابط الموجود في بريدك.',
		tryAgain: 'إعادة المحاولة',
	},
};

export default ar;
